<div class="PageContainer">
    <ng-content></ng-content>
</div>
